import { GalerieItemText } from '@components/galerie/models';

export const galerieTextMock: GalerieItemText = {
  title: {
    text: `Pantone dévoile sa couleur 2025 [[super tendance !]]`,
    as: 'span',
  },
  subtitle: `Pour des cuisine naturelles`,
};
